import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  setSection,
  openItem,
  closeTopPanel,
  showGalleryOnly,
  showHeroBanner,
  hideSectionBanner,
  showSectionBanner,
  disolvePrivateService,
  showPrivateService,
  showTeamInfoPanel,
  hideTeamInfoPanel,
  hideEditorialLayout,
  showBlog,
  hideBlog,
  setServiceData,
  showFaq,
  hideSingleFAQ,
  showEditorialLayout,
  showContentSection,
  showTeamsMenu,
  hideServiceList,
  closePanels,
  hidePrivateService,
  showServiceList,
  hideTeamsMenu,
  hideFaq,
  hideContact,
  showServicePhilosophy,
  hideServicePhilosophy,
  showContact,
  endHeaderFade,
  endPanelInfoFade,
  hideAcceptingForm,
  openGalleryOfService,
  closeGalleryOfService,
  selectMember,
} from "./features/serviceSlice";
import { toSlug } from "./utils/slug";
import BlackLabel from "./component/BlackLabel";
import PanelInfoHeader from "./component/PanelInfoHeader";
import TeamProfilePanel from "./component/teams/TeamProfilePanel";
import TeamInfoPanel from "./component/teams/TeamInfoPanel";
import EditorialLayout from "./component/blogs/EditorialLayout";
import BlogView from "./component/blogs/BlogView";
import ServicePhilosophy from "./component/philosophy/ServicePhilosophy";
import ContactEditorial from "./component/faq/ContactEditorial";
import FaqEditorial from "./component/faq/FaqEditorial";
import Faqs from "./component/faq/Faqs";
import AcceptingForm from "./component/AcceptingForm";
import {
  LEGACY_SERVICE_DESCRIPTION_SECTION_TITLE,
  SERVICE_DESCRIPTION_SECTION_TITLE,
} from "./constants/copy";
import axios from "axios";
import heroVideo from "./assets/hero-video.mp4";
import logo from "./assets/img/logo_img.png";

const serviceDescriptionSectionTitlePattern = new RegExp(
  LEGACY_SERVICE_DESCRIPTION_SECTION_TITLE,
  "gi",
);

const applyGlobalServiceCopy = (html = "") =>
  html.replace(
    serviceDescriptionSectionTitlePattern,
    SERVICE_DESCRIPTION_SECTION_TITLE,
  );

export default function Layout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rightFix, setRightFix] = useState("");
  const [isMenuSwitching, setIsMenuSwitching] = useState(false);
  const [isGallerySwitching, setIsGallerySwitching] = useState(false);
  const [isTeamProfilePeeked, setIsTeamProfilePeeked] = useState(false);
  const [galleryDisplayItem, setGalleryDisplayItem] = useState(null);
  const [openServiceDescriptionIndex, setOpenServiceDescriptionIndex] =
    useState(null);
  const [isServiceFooterLegalExpanded, setIsServiceFooterLegalExpanded] =
    useState(false);
  const [isMobileAcceptingFormClosing, setIsMobileAcceptingFormClosing] =
    useState(false);
  const serviceInfoRef = useRef(null);
  const panelInfoInnerRef = useRef(null);
  const galleryPanelRef = useRef(null);
  const galleryDisplayItemRef = useRef(null);
  const galleryTouchStartYRef = useRef(null);
  const gallerySwitchTimersRef = useRef([]);
  const mobileAcceptingCloseTimerRef = useRef(null);
  const isMobile = window.innerWidth <= 768;
  const isMobileAcceptingViewport = window.innerWidth <= 840;

  const location = useLocation();

  const segments = location.pathname.split("/").filter(Boolean);

  // Example:
  // /services/wardrobe-services/couture-hand-cleaning
  // ["services", "wardrobe-services", "couture-hand-cleaning"]

  const sectionSlug = segments[1];
  const itemSlug = segments[2];

  const {
    activeItem,
    activeCardLabel,
    showGallery,
    openGallery,
    openInfoSlideGallery,
    showInfo,
    expanded,
    showTopHeroBanner,
    showTopServiceBanner,
    sectionBanner,
    serviceList,
    switchServiceList,
    privateService,
    teamsMenu,
    disolveprivateService,
    isTeamInfoPanel,
    iseditorialLayout,
    isIndividualBlog,
    isServicePhilosophy,
    isFaq,
    isContact,
    issingleFAQ,
    isMenuSectionClicked,
    serviceData,
    activeSection,
    isHeaderFading,
    isPanelInfoFading,
    isAcceptingFormOpen,
    selectedTeamMember,
  } = useSelector((state) => state.service);
  const hasSelectedTeamMember =
    selectedTeamMember !== null && selectedTeamMember !== undefined;

  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API + "/service", {
        params: { _ts: Date.now() },
      });

      dispatch(setServiceData(response.data));
    } catch (error) {
      console.error("API error:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (teamsMenu) {
      setTimeout(() => {
        setRightFix("fix");
      }, 600);
    } else {
      setTimeout(() => {
        setRightFix("");
      }, 600);
    }
  }, [teamsMenu]);

  useEffect(() => {
    if (!isHeaderFading) return;
    const timer = setTimeout(() => {
      dispatch(endHeaderFade());
    }, 600);
    return () => clearTimeout(timer);
  }, [dispatch, isHeaderFading]);

  useEffect(() => {
    if (!isPanelInfoFading) return;
    const timer = setTimeout(() => {
      dispatch(endPanelInfoFade());
    }, 2700);
    return () => clearTimeout(timer);
  }, [dispatch, isPanelInfoFading]);

  useEffect(() => {
    const resetServiceScroll = () => {
      if (serviceInfoRef.current) {
        serviceInfoRef.current.scrollTop = 0;
      }

      if (panelInfoInnerRef.current) {
        panelInfoInnerRef.current.scrollTop = 0;
      }

      if (galleryPanelRef.current) {
        galleryPanelRef.current.scrollTop = 0;
      }

      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    };

    resetServiceScroll();
    const frame = requestAnimationFrame(resetServiceScroll);
    const timer = setTimeout(resetServiceScroll, 50);

    return () => {
      cancelAnimationFrame(frame);
      clearTimeout(timer);
    };
  }, [activeItem, itemSlug, location.pathname]);

  useEffect(() => {
    galleryDisplayItemRef.current = galleryDisplayItem;
  }, [galleryDisplayItem]);

  useEffect(() => {
    return () => {
      gallerySwitchTimersRef.current.forEach(clearTimeout);
      if (mobileAcceptingCloseTimerRef.current) {
        clearTimeout(mobileAcceptingCloseTimerRef.current);
      }
    };
  }, []);

  const closeAcceptingForm = useCallback(() => {
    if (!isMobileAcceptingViewport) {
      dispatch(hideAcceptingForm());
      dispatch(showContentSection());
      return;
    }

    if (mobileAcceptingCloseTimerRef.current) {
      clearTimeout(mobileAcceptingCloseTimerRef.current);
    }

    setIsMobileAcceptingFormClosing(true);
    mobileAcceptingCloseTimerRef.current = setTimeout(() => {
      dispatch(hideAcceptingForm());
      dispatch(showContentSection());
      setIsMobileAcceptingFormClosing(false);
      mobileAcceptingCloseTimerRef.current = null;
    }, 500);
  }, [dispatch, isMobileAcceptingViewport]);

  const openCollapsedGalleryFromScroll = useCallback(() => {
    if (!showGallery || openGallery || isGallerySwitching) return;

    dispatch(openGalleryOfService());
  }, [dispatch, isGallerySwitching, openGallery, showGallery]);

  useEffect(() => {
    if (!activeItem) return;

    const clearGallerySwitchTimers = () => {
      gallerySwitchTimersRef.current.forEach(clearTimeout);
      gallerySwitchTimersRef.current = [];
    };

    const currentItem = galleryDisplayItemRef.current;
    const currentItemKey = currentItem?.id ?? currentItem?.label;
    const nextItemKey = activeItem.id ?? activeItem.label;

    if (!isMobile || !currentItem) {
      clearGallerySwitchTimers();
      setGalleryDisplayItem(activeItem);
      galleryDisplayItemRef.current = activeItem;
      setIsGallerySwitching(false);
      return;
    }

    if (currentItemKey === nextItemKey) return;

    clearGallerySwitchTimers();
    setIsGallerySwitching(true);

    const swapTimer = setTimeout(() => {
      setGalleryDisplayItem(activeItem);
      galleryDisplayItemRef.current = activeItem;

      const revealTimer = setTimeout(() => {
        setIsGallerySwitching(false);
      }, 40);

      gallerySwitchTimersRef.current = [revealTimer];
    }, 800);

    gallerySwitchTimersRef.current = [swapTimer];
  }, [activeItem, isMobile]);

  useEffect(() => {
    if (!isMenuSwitching) return;
    const timer = setTimeout(() => {
      setIsMenuSwitching(false);
    }, 1650);
    return () => clearTimeout(timer);
  }, [activeItem, isMenuSwitching]);

  useEffect(() => {
    setOpenServiceDescriptionIndex(null);
  }, [activeItem]);

  useEffect(() => {
    setIsTeamProfilePeeked(false);
  }, [selectedTeamMember]);

  useEffect(() => {
    setIsServiceFooterLegalExpanded(false);
  }, [location.pathname]);

  //To collapse the left seciton on moblile view:
  //   const isMobile = window.innerWidth <= 900;
  //   if (isMobile) {
  //     dispatch(collapseContentSection());
  //     dispatch(closeTopPanel());
  //   }

  /* 🔁 URL → REDUX (SAFE & DATA-DRIVEN) */
  useEffect(() => {
    if (!serviceData || serviceData.length === 0) return;

    const path = location.pathname;

    if (path === "/") {
      dispatch(showHeroBanner());
      return;
    }

    // RESET UI STATE FIRST
    dispatch(hideEditorialLayout());
    dispatch(hideBlog());
    dispatch(hideSingleFAQ());
    dispatch(hideTeamInfoPanel());
    // dispatch(closePanels())

    // ======================
    // SERVICES ROUTES
    // ======================
    if (path.startsWith("/services")) {
      if (!sectionSlug) {
        dispatch(showHeroBanner());
        return;
      }

      const matchedSection = serviceData.find(
        (s) => toSlug(s.title) === sectionSlug,
      );

      if (!matchedSection) return;

      dispatch(showContentSection());
      dispatch(hideTeamsMenu());
      dispatch(hideFaq());
      dispatch(hideContact());
      dispatch(hidePrivateService());

      // Ensure correct section
      if (activeSection !== matchedSection.title) {
        dispatch(setSection(matchedSection.title));
      }

      dispatch(hideSectionBanner());
      dispatch(hideServiceList());

      setTimeout(() => {
        dispatch(showSectionBanner());
      }, 900);

      setTimeout(() => {
        dispatch(showServiceList());
      }, 1400);

      if (itemSlug) {
        const matchedItem = matchedSection.items?.find(
          (i) => toSlug(i.label) === itemSlug,
        );

        if (matchedItem) {
          dispatch(openItem(matchedItem));
        }
      }
    }

    // ======================
    // TEAM ROUTES
    // ======================
    if (path.startsWith("/team")) {
      dispatch(closePanels());
      dispatch(showContentSection());
      dispatch(showTeamsMenu());
      dispatch(selectMember(isMobile ? null : 0));
      // dispatch(hidePrivateService())
      dispatch(hideServiceList());
      dispatch(closePanels());
    }

    // ======================
    // BLOG ROUTES
    // ======================
    if (path.startsWith("/blogs")) {
      dispatch(closePanels());
      dispatch(showContentSection());
      dispatch(hideTeamsMenu());
      dispatch(hideServiceList());
      setTimeout(() => {
        dispatch(showEditorialLayout());
        navigate(`/blogs`);
      }, 500);

      if (sectionSlug) {
        dispatch(showBlog(sectionSlug));
      }
    }

    // ======================
    // FAQ ROUTES
    // ======================
    if (path.startsWith("/faq")) {
      dispatch(closePanels());
      dispatch(showContentSection());
      dispatch(hideTeamsMenu());
      dispatch(hideServiceList());
      dispatch(hideServicePhilosophy());
      dispatch(showFaq());
    }

    if (path.startsWith("/philosophy")) {
      dispatch(closePanels());
      dispatch(showContentSection());
      dispatch(showServicePhilosophy());
      dispatch(hideTeamsMenu());
      dispatch(hideServiceList());
    }

    if (path.startsWith("/contact")) {
      dispatch(closeTopPanel());
      dispatch(showContentSection());
      dispatch(hideTeamsMenu());
      dispatch(hideServiceList());
      dispatch(hideServicePhilosophy());
      dispatch(hideFaq());
      dispatch(showContact());
    }
  }, [
    serviceData,
    location.pathname,
    activeSection,
    dispatch,
    isMobile,
    itemSlug,
    navigate,
    sectionSlug,
  ]);

  let section = null;

  const selectedSection = serviceData?.find(
    (s) => toSlug(s.title) === sectionSlug,
  );

  if (selectedSection) {
    section = selectedSection;
  } else {
    section = serviceData?.find((x) => x.title === "Wardrobe Services");
  }

  const isServicesRoute = location.pathname.startsWith("/services");
  const menuSection =
    isServicesRoute && sectionSlug
      ? serviceData?.find((s) => toSlug(s.title) === sectionSlug)
      : null;

  const getContextualMenuItems = (currentSection) => {
    if (!currentSection?.items?.length) return [];

    const preferredOrderBySlug = {
      "wardrobe-services": [
        "Collection and Delivery",
        "Couture Hand Cleaning",
        "Alterations and Tailoring",
        "Quality Dry Cleaning",
        "Leather and Suede",
        "Wash and Fold",
        "Wedding Dress",
        "Garment Restorations",
        "Wardroe Inventory",
        "Wardrobe Inventory",
        "Wardrobe Monetization",
        "Mold Remediation",
      ],
    };

    const preferred = preferredOrderBySlug[toSlug(currentSection.title)];
    if (!preferred) return currentSection.items;

    const normalize = (label) => label.trim().toLowerCase();
    const remaining = new Map(
      currentSection.items.map((item) => [normalize(item.label), item]),
    );
    const ordered = [];

    preferred.forEach((label) => {
      const key = normalize(label);
      const match = remaining.get(key);
      if (match) {
        ordered.push(match);
        remaining.delete(key);
      }
    });

    currentSection.items.forEach((item) => {
      const key = normalize(item.label);
      if (remaining.has(key)) {
        ordered.push(item);
        remaining.delete(key);
      }
    });

    return ordered;
  };

  const resolvedMenuSection = menuSection || section || null;

  const contextualMenuItems = resolvedMenuSection
    ? getContextualMenuItems(resolvedMenuSection)
    : [];

  const getSectionLabel = (title) => {
    if (!title) return "";
    const normalized = title.trim().toLowerCase();
    if (normalized.startsWith("wardrobe")) return "Wardrobes";
    if (normalized.startsWith("estate")) return "Estates";
    if (normalized.startsWith("vessel")) return "Vessels";
    return title;
  };

  const sectionLabel = getSectionLabel(resolvedMenuSection?.title);

  const nextServiceItem = (() => {
    if (!contextualMenuItems.length || !activeItem) return null;
    if (contextualMenuItems.length <= 1) return null;
    const currentIndex = contextualMenuItems.findIndex(
      (item) => item.label === activeItem.label,
    );
    if (currentIndex === -1) return null;
    const nextIndex = (currentIndex + 1) % contextualMenuItems.length;
    return contextualMenuItems[nextIndex];
  })();

  const visibleGalleryImages = galleryDisplayItem?.gallery_images;
  const serviceDescriptionContent = useMemo(() => {
    if (!activeItem?.description || typeof document === "undefined") {
      return {
        introHtml: applyGlobalServiceCopy(activeItem?.description || ""),
        sections: [],
      };
    }

    const serviceDescriptionHtml = applyGlobalServiceCopy(
      activeItem.description,
    );
    const wrapper = document.createElement("div");
    wrapper.innerHTML = serviceDescriptionHtml;
    const h2Headings = Array.from(wrapper.querySelectorAll("h2"));
    const headings = h2Headings.length
      ? h2Headings
      : Array.from(wrapper.querySelectorAll("h3"));

    if (!headings.length) {
      return { introHtml: serviceDescriptionHtml, sections: [] };
    }

    const serializeRange = (startNode, startOffset, endNode, endOffset) => {
      const range = document.createRange();
      range.setStart(startNode, startOffset);
      range.setEnd(endNode, endOffset);

      const container = document.createElement("div");
      container.appendChild(range.cloneContents());
      range.detach();
      return container.innerHTML;
    };

    const introHtml = serializeRange(
      wrapper,
      0,
      headings[0].parentNode,
      Array.prototype.indexOf.call(headings[0].parentNode.childNodes, headings[0]),
    );

    return {
      introHtml,
      sections: headings.map((heading, index) => ({
        titleHtml: heading.innerHTML,
        contentHtml: serializeRange(
          heading.parentNode,
          Array.prototype.indexOf.call(heading.parentNode.childNodes, heading) +
            1,
          headings[index + 1]?.parentNode || wrapper,
          headings[index + 1]
            ? Array.prototype.indexOf.call(
                headings[index + 1].parentNode.childNodes,
                headings[index + 1],
              )
            : wrapper.childNodes.length,
        ),
      })),
    };
  }, [activeItem?.description]);

  //   if (!section) return null;

  return (
    <div className="wrapper">
      {/* LEFT */}
      <div
        className={`left ${showInfo ? "mobile-service-detail-active" : ""} ${isAcceptingFormOpen ? "" : isMenuSectionClicked ? "collapse" : ""} ${expanded ? "expand" : ""} ${teamsMenu && !hasSelectedTeamMember ? "team-empty-selection" : ""} ${teamsMenu && !isTeamInfoPanel ? "w-42" : ""} ${teamsMenu && isTeamInfoPanel ? "w-72" : ""} ${isFaq || isContact || issingleFAQ || isServicePhilosophy ? "w-75" : ""} ${iseditorialLayout ? "w-82" : ""} ${!serviceList && !expanded && !switchServiceList && !showTopHeroBanner ? "w-46" : ""}`}
      >
        {/* UNDER PANEL */}
        {section ? (
          <div
            className={`panel-under ${teamsMenu ? "d-none" : ""}`}
            onClick={() => {
              if (issingleFAQ) {
                dispatch(showFaq());
                dispatch(hideSingleFAQ());
              } else if (isIndividualBlog) {
                dispatch(showEditorialLayout());
                dispatch(hideBlog());
              } else {
                dispatch(hideSingleFAQ());
                dispatch(closeTopPanel());
                // dispatch(showHeroBanner())
                dispatch(hideSectionBanner());
                dispatch(hideEditorialLayout());
                setTimeout(() => {
                  if (expanded) {
                    // dispatch(showSectionBanner());
                    dispatch(showPrivateService());
                  }
                  navigate(`/services/${toSlug(section.title)}`);
                }, 800);
              }
            }}
          >
            <div
              className={`service-list-container ${showGallery ||
                showInfo ||
                showTopHeroBanner ||
                isFaq ||
                iseditorialLayout ||
                isContact ||
                issingleFAQ ||
                sectionBanner ||
                isServicePhilosophy
                ? "move"
                : ""
                }`}
            >
              <div className="wardrobe-grid">
                {section?.items?.map((item, i) => {
                  const isFullWidth = (i + 1) % 3 === 0;

                  return (
                    <div
                      key={item.label}
                      className={`wardrobe-card 
                                                        ${activeCardLabel === item.label ? "active" : ""} 
                                                        ${isFullWidth ? "w-full" : ""}
                                                    `}
                      onClick={(e) => {
                        if (
                          expanded ||
                          showTopHeroBanner ||
                          showTopServiceBanner ||
                          sectionBanner ||
                          teamsMenu ||
                          isServicePhilosophy ||
                          iseditorialLayout ||
                          isFaq ||
                          isContact ||
                          issingleFAQ
                        ) {
                        } else {
                          e.stopPropagation();
                          dispatch(closeGalleryOfService());
                          dispatch(openItem(item));
                          if (privateService) {
                            dispatch(disolvePrivateService());
                          }
                          navigate(
                            `/services/${toSlug(section.title)}/${toSlug(item.label)}`,
                          );
                        }
                      }}
                    >
                      <img src={item.image || item.gallery_images[0]} alt="" />
                      <span>{item.label}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        {/* TOP PANEL */}
        <div className={`panel-top ${showTopServiceBanner ? "reveal" : ""}`}>
          <div className={`panel-bg`} />
        </div>
        <div
          className={`panel-top ${!showTopServiceBanner && showTopHeroBanner ? "reveal" : ""}`}
        >
          <video
            className="hero-bg"
            src={heroVideo}
            autoPlay
            muted
            playsInline
          />
        </div>
        <div className={`panel-top ${sectionBanner ? "reveal" : ""}`}>
          <div
            style={{
              position: "absolute",
              inset: "20px",
              background: `url(${section?.banner_image}) center / cover no-repeat`,
            }}
          />
        </div>

        {/* TEAMS PANEL */}

        <div
          onClick={() => {
            if (!hasSelectedTeamMember) return;
              dispatch(showTeamInfoPanel());
          }}
          className={`team-info-panel ${privateService ? "d-none" : ""} ${teamsMenu && hasSelectedTeamMember ? "" : "d-none"} ${disolveprivateService ? "disolve" : ""} ${isTeamInfoPanel ? "slide-right" : ""} ${isTeamProfilePeeked ? "mobile-profile-peeked" : ""}`}
        >
          <TeamInfoPanel />
        </div>
        <div
          onClick={(e) => {
            if (!isMobile) {
              dispatch(hideTeamInfoPanel());
              return;
            }

            e.stopPropagation();
            setIsTeamProfilePeeked((isPeeked) => !isPeeked);
          }}
          className={`team-profile-panel ${privateService ? "d-none" : ""} ${teamsMenu && hasSelectedTeamMember ? "" : "d-none"} ${disolveprivateService ? "disolve" : ""} ${isTeamInfoPanel ? "slide-left" : ""} ${isTeamProfilePeeked ? "mobile-peek" : ""}`}
        >
          <TeamProfilePanel />
        </div>

        {/* TEAMS PANEL */}

        {/* BLOGS PANELS */}

        <div
          onClick={() => {
            // e.stopPropagation()
            dispatch(hideBlog());
          }}
          className={`blog-list-panel ${privateService ? "d-none" : ""} ${teamsMenu ? "d-none" : ""} ${disolveprivateService ? "disolve" : ""} ${iseditorialLayout ? "" : "d-none"}`}
        >
          <EditorialLayout />
        </div>

        <div
          onClick={(e) => {
            e.stopPropagation();
            dispatch(showBlog(1));
          }}
          className={`blog-panel ${isIndividualBlog ? "show" : ""} ${privateService ? "d-none" : ""} ${teamsMenu ? "d-none" : ""} ${disolveprivateService ? "disolve" : ""} ${iseditorialLayout ? "" : "d-none"}`}
        >
          <BlogView />
        </div>

        {/* BLOGS PANELS */}

        {/* PHILOSOPHY PANELS */}

        <div
          onClick={(e) => { }}
          className={`philosophy-panel ${isServicePhilosophy ? "" : "d-none"} ${isIndividualBlog ? "d-none" : ""} ${privateService ? "d-none" : ""} ${teamsMenu ? "d-none" : ""} ${disolveprivateService ? "disolve" : ""} ${iseditorialLayout ? "d-none" : ""}`}
        >
          <ServicePhilosophy />
        </div>

        {/* PHILOSOPHY PANELS */}

        {/* FAQ PANELS */}

        <div
          onClick={(e) => { }}
          className={`faq-panel ${isFaq ? "" : "d-none"} ${isIndividualBlog ? "d-none" : ""} ${privateService ? "d-none" : ""} ${teamsMenu ? "d-none" : ""} ${disolveprivateService ? "disolve" : ""} ${iseditorialLayout ? "d-none" : ""}`}
        >
          {/* <ContactEditorial /> */}
          <FaqEditorial />
        </div>

        <div
          onClick={(e) => { }}
          className={`contact-panel ${isContact ? "" : "d-none"} ${isIndividualBlog ? "d-none" : ""} ${privateService ? "d-none" : ""} ${teamsMenu ? "d-none" : ""} ${disolveprivateService ? "disolve" : ""} ${iseditorialLayout ? "d-none" : ""}`}
        >
          {/* <ContactEditorial /> */}
          <ContactEditorial />
        </div>

        <div
          onClick={(e) => { }}
          className={`single-faq-panel ${issingleFAQ ? "" : "d-none"} ${isIndividualBlog ? "d-none" : ""} ${privateService ? "d-none" : ""} ${teamsMenu ? "d-none" : ""} ${disolveprivateService ? "disolve" : ""} ${iseditorialLayout ? "d-none" : ""}`}
        >
          {/* <ContactEditorial /> */}
          <Faqs />
        </div>

        {/* FAQ PANELS */}

        {/* GALLERY PANEL */}
        <div
          ref={galleryPanelRef}
          className={`panel-gallery ${showGallery ? "reveal" : ""} ${openGallery ? "show" : ""} ${openInfoSlideGallery ? "slide-left" : ""} ${isGallerySwitching ? "menu-switching" : ""}`}
          onWheel={(e) => {
            if (!openGallery && e.deltaY > 8) {
              e.preventDefault();
              openCollapsedGalleryFromScroll();
            } else if (openGallery && e.currentTarget.scrollTop <= 0 && e.deltaY < -8) {
              e.preventDefault();
              dispatch(closeGalleryOfService());
            }
          }}
          onTouchStart={(e) => {
            galleryTouchStartYRef.current = e.touches[0]?.clientY ?? null;
          }}
          onTouchMove={(e) => {
            if (galleryTouchStartYRef.current === null) return;

            const currentY = e.touches[0]?.clientY;
            if (currentY === undefined) return;

            const upwardSwipeDistance = galleryTouchStartYRef.current - currentY;
            const downwardSwipeDistance = currentY - galleryTouchStartYRef.current;

            if (!openGallery && upwardSwipeDistance > 18) {
              e.preventDefault();
              galleryTouchStartYRef.current = null;
              openCollapsedGalleryFromScroll();
            } else if (
              openGallery &&
              e.currentTarget.scrollTop <= 0 &&
              downwardSwipeDistance > 24
            ) {
              e.preventDefault();
              galleryTouchStartYRef.current = null;
              dispatch(closeGalleryOfService());
            }
          }}
          onTouchEnd={() => {
            galleryTouchStartYRef.current = null;
          }}
          onClick={(e) => {
            if (openGallery) {
              dispatch(closeGalleryOfService());
            } else {
              dispatch(openGalleryOfService());
            }
            if (openInfoSlideGallery) {
              e.stopPropagation();

              dispatch(showGalleryOnly());
            }
          }}
        >
          {visibleGalleryImages?.length > 0 && (
            <div className="wardrobe-grid">
              {visibleGalleryImages.map((img, i) => (
                <img key={i} src={img} alt="" style={{ width: "100%" }} />
              ))}
            </div>
          )}
        </div>

        {/* INFO PANEL */}
        <div
          className={`panel-info ${showInfo ? "reveal" : ""}`}
        // onClick={(e) => {
        //     e.stopPropagation();
        //     dispatch(closeGalleryOnly());
        // }}
        >
          <div
            ref={panelInfoInnerRef}
            className={`panel-info-inner ${isPanelInfoFading ? "is-fading" : ""}`}
          >
            <div className="panel-info-header">
              <PanelInfoHeader />
            </div>
            <div className="panel-info-body">
              <div className="service-info-layout">
                {showInfo && resolvedMenuSection ? (
                  <div className="service-context-menu">
                    <div className="menu-title">Menu</div>
                    <ul className="menu-list">
                      {contextualMenuItems.map((item) => (
                        <li
                          key={item.id || item.label}
                          className={
                            activeItem?.label === item.label ? "active" : ""
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            if (activeItem?.label === item.label) return;
                            setIsMenuSwitching(true);
                            setIsGallerySwitching(true);
                            dispatch(closeGalleryOfService());
                            dispatch(showContentSection());
                            setTimeout(() => {
                              navigate(
                                `/services/${toSlug(resolvedMenuSection.title)}/${toSlug(item.label)}`,
                              );
                            }, 1700);
                          }}
                        >
                          {item.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null}
                {activeItem ? (
                  <div
                    className={`service-info-content ${isMenuSwitching ? "is-fading" : ""}`}
                    ref={serviceInfoRef}
                  >
                    <div className="service-info-container">
                      <div
                        className={`service-detail-header ${isHeaderFading ? "is-fading" : ""}`}
                      >
                        <div className="service-detail-header-inner">
                          <span className="service-section-label">
                            {sectionLabel}
                          </span>
                          <span
                            className={`service-detail-title ${isMenuSwitching ? "is-fading" : ""}`}
                          >
                            {activeItem?.label}
                          </span>
                        </div>
                      </div>
                      {activeItem?.item_featured_image ? (
                        <img
                          className="service-info-featured-image"
                          src={activeItem.item_featured_image}
                          alt=""
                        />
                      ) : null}
                      <h2
                        dangerouslySetInnerHTML={{
                          __html: activeItem.item_feature_image_subheading,
                        }}
                      />
                      <div className="service-info-description">
                        {serviceDescriptionContent.introHtml ? (
                          <div
                            className="service-info-description-intro"
                            dangerouslySetInnerHTML={{
                              __html: serviceDescriptionContent.introHtml,
                            }}
                          />
                        ) : null}

                        {serviceDescriptionContent.sections.length ? (
                          <div className="service-description-accordion">
                            {serviceDescriptionContent.sections.map(
                              (section, index) => {
                                const isOpen =
                                  openServiceDescriptionIndex === index;

                                return (
                                  <div
                                    key={`${section.titleHtml}-${index}`}
                                    className={`service-description-accordion-item ${isOpen ? "open" : ""}`}
                                    onClick={() =>
                                      setOpenServiceDescriptionIndex(
                                        isOpen ? null : index,
                                      )
                                    }
                                  >
                                    <div className="service-description-accordion-question">
                                      <h2
                                        dangerouslySetInnerHTML={{
                                          __html: section.titleHtml,
                                        }}
                                      />
                                      <span className="service-description-accordion-arrow">
                                        <svg
                                          width="12"
                                          height="8"
                                          viewBox="0 0 12 8"
                                          fill="none"
                                        >
                                          <path
                                            d="M1 1L6 6L11 1"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                          />
                                        </svg>
                                      </span>
                                    </div>

                                    <div className="service-description-accordion-answer-wrapper">
                                      <div
                                        className="service-description-accordion-answer"
                                        dangerouslySetInnerHTML={{
                                          __html: section.contentHtml,
                                        }}
                                      />
                                    </div>
                                  </div>
                                );
                              },
                            )}
                          </div>
                        ) : (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: applyGlobalServiceCopy(
                                activeItem.description,
                              ),
                            }}
                          />
                        )}
                      </div>
                      {nextServiceItem ? (
                        <button
                          className="service-next-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsMenuSwitching(true);
                            setIsGallerySwitching(true);
                            dispatch(closeGalleryOfService());
                            dispatch(showContentSection());
                            setTimeout(() => {
                              navigate(
                                `/services/${toSlug(resolvedMenuSection.title)}/${toSlug(nextServiceItem.label)}`,
                              );
                            }, 1700);
                          }}
                        >
                          Explore {nextServiceItem.label}
                        </button>
                      ) : null}
                    </div>
                    <footer className="service-detail-footer">
                      <p>
                        <button
                          className="service-detail-footer-toggle"
                          type="button"
                          aria-expanded={isServiceFooterLegalExpanded}
                          onClick={() =>
                            setIsServiceFooterLegalExpanded(
                              (expanded) => !expanded,
                            )
                          }
                        >
                          © 2026 Sudsies, Inc. All rights reserved.
                        </button>
                        {isServiceFooterLegalExpanded ? (
                          <span className="service-detail-footer-details">
                            {" "}
                            All trademarks, logos and brand names are the
                            property of their respective owners. Use of these
                            names, trademarks and brands does not imply
                            endorsement.
                          </span>
                        ) : null}
                      </p>
                      <img src={logo} alt="Sudsies Black Label" />
                    </footer>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        {/* ACCEPTING FORM PANEL */}
        <div
          className={`accepting-form-panel ${isAcceptingFormOpen ? "show" : ""}`}
        >
          <AcceptingForm
            isOpen={isAcceptingFormOpen}
            onClose={closeAcceptingForm}
          />
        </div>
      </div>

      {(isAcceptingFormOpen || isMobileAcceptingFormClosing) &&
      isMobileAcceptingViewport ? (
        <div
          className={`mobile-accepting-overlay ${isMobileAcceptingFormClosing ? "closing" : ""}`}
        >
          <AcceptingForm
            isOpen={isAcceptingFormOpen}
            onClose={closeAcceptingForm}
          />
        </div>
      ) : null}

      {/* RIGHT */}
      <div
        className={`right ${rightFix} ${isTeamInfoPanel ? "dark-shade" : ""}`}
      >
        <BlackLabel />
      </div>
    </div>
  );
}
